import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartLine } from "@fortawesome/free-solid-svg-icons";

const Section3 = ({ url }) => {

const cards = [
  {
    title: "Full Project Delivery",
    subtitle: "Hand your project to a complete, managed offshore team",
    bullets: [
      "ExD Digital assembles a full project team: developers, QA, and project management",
      "You define the outcome and review progress at regular milestones. We handle execution",
      "Ideal for businesses with a defined scope but without internal bandwidth to manage a development team",
      "Fixed deliverables, transparent milestones, and accountable project management throughout",
      "Technology stack selected based on your requirements, not our convenience"
    ],
    bestFor: "Best for: Startups, growing businesses, and enterprises with a scoped project and no internal dev team",
    dashed: true,
  },
  {
    title: "Dedicated Team Extension",
    subtitle: "Embed ExD Digital developers directly into your existing team",
    bullets: [
      "Hire one developer or an entire squad, starting from a single resource with no minimum commitment",
      "Your developers, your processes, your tools, your standup. We provide the talent Ideal for engineering teams that need to scale capacity without the cost and delay of local hiring",
      "Developers are fully dedicated to your team, not shared across multiple clients",
      "Flexible engagement: start with one month, scale up or down as your project evolves"
    ],
    bestFor: "Best for: Tech companies, SaaS businesses, and engineering teams that need to scale fast without local hiring costs",
    dashed: false,
  }
];

  return (
    <section className="home-section-3">
      <div className="container overflow-hidden">

        <h2 className="s3-title" data-aos="fade-up">
          Two Ways to Work With ExD Digital's Offshore Teams
        </h2>

        <p className="s3-subtitle" data-aos="fade-up" data-aos-delay="100">
          Your needs determine the model. Not the other way around. Both options start with a free
          discovery call where we map your requirement to the right structure before any commitment
          is made.
        </p>

        <div className="s3-cards-row" data-aos="fade-up" data-aos-delay="200">
          {cards.map((card, idx) => (
            <div
              className={`s3-card ${card.dashed ? "s3-card--dashed" : "s3-card--solid"}`}
              key={idx}
            >
              <div className="s3-card-top">
                <h3 className="s3-card-title">{card.title}</h3>
                <p className="s3-card-subtitle">{card.subtitle}</p>
              </div>

              <ul className="s3-card-bullets">
                {card.bullets.map((b, i) => (
                  <li key={i}>{b}</li>
                ))}
              </ul>

              <p className="s3-card-best">{card.bestFor}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Section3;